// Libraries
import { LatLng } from "leaflet";
import { County, State, Indicator, EquityIndicator } from "./Types"

export const selectVariable = {
    changeYear: [
                 {id: '0', descr: 'Overall Change', geYear: 2012, baseYear: 2022, changeYear: 'Overall Change', decennialCensusYear: 2020, ms: true, mi: true, ga: true, la: true, nc: true, oh: true, pa: true, wi: true, sc: true},
                 {id: '1', descr: '2020 – 2022', geYear: 2020, baseYear: 2022, changeYear: '2020 - 2022', decennialCensusYear: 2020, ms: true, mi: true, ga: true, la: false, nc: true, oh: false, pa: true, wi: true, sc: true},
                 {id: '2', descr: '2018 – 2020', geYear: 2018, baseYear: 2020, changeYear: '2018 - 2020', decennialCensusYear: 2020, ms: true, mi: false, ga: true, la: true, nc: true, oh: true, pa: true, wi: true, sc: true},
                 {id: '3', descr: '2016 – 2018', geYear: 2016, baseYear: 2018, changeYear: '2016 - 2018', decennialCensusYear: 2010, ms: true, mi: false, ga: true, la: true, nc: true, oh: true, pa: true, wi: true, sc: true},
                 {id: '4', descr: '2014 – 2016', geYear: 2014, baseYear: 2016, changeYear: '2014 - 2016', decennialCensusYear: 2010, ms: true, mi: false, ga: false, la: true, nc: true, oh: true, pa: true, wi: true, sc: true},
                 {id: '5', descr: '2012 – 2014', geYear: 2012, baseYear: 2014, changeYear: '2012 - 2014', decennialCensusYear: 2010, ms: true, mi: true, ga: false, la: true, nc: true, oh: true, pa: true, wi: true, sc: true}
                ],
    equityIndicator: [
                      {variable: 'baseYearPctCVAPBlack', descr: '% Black CVAP', descrLong:'% Black CVAP'},
                      {variable: 'baseYearPctCVAPHispanic', descr: '% Hispanic CVAP', descrLong:'% Hispanic CVAP'},
                      {variable: 'baseYearPopDensity', descr: 'Population density', descrLong: 'Population density (# people per square mile)'}
                ],
    indicator: [{variable: 'changeNoPolls', descr: 'Net gain or loss of poll locations', sizeDescr: "Total # poll location changes"},
                {variable: 'changeYearCVAPPerPoll', descr: 'Change in # of CVAP per poll', sizeDescr: "Total # of CVAP per poll location"}]
}

export function IndicatorLabel(indicator: Indicator) {

    if (indicator.variable === "changeNoPolls") {
        return (<div>Net gain or loss of poll locations</div>)
    } else {
        return (<div>Per capita net gain or loss of poll locations</div>)
    }
}

export function IndicatorColorLabel(indicator: Indicator) {

    if (indicator.variable === "changeNoPolls") {
        return (<div>Net gain or loss of poll locations</div>)
    } else {
        return (<div><span>Change in # of </span><span className="CVAP">CVAP </span><span>per poll location</span></div>)
    }
}

export function IndicatorSizeLabel(indicator: Indicator) {

    if (indicator.variable === "changeNoPolls") {
        return (<div>Total # poll location changes</div>)
    } else {
        return (<div><span>Total # of </span><span className="CVAP">CVAP </span><span>per poll location</span></div>)
    }
}

export function EquityIndicatorLabel(equityIndicator: EquityIndicator) {

    if (equityIndicator.variable === "baseYearPopDensity") {
        return (<div>Population density (# people per square mile)</div>)
    } else if (equityIndicator.variable === "baseYearPctCVAPHispanic") {
        return (<div><span>% Hispanic </span><span className="CVAP">CVAP </span></div>)
    } else {
        return (<div><span>% Black </span><span className="CVAP">CVAP </span></div>)
    }
}

export const outerBounds: [number, number][] = 
    [[5.499550, -167.276413], //Southwest
    [83.162102, -19]] //Northeast

export const defaultMap =  {name: 'United States',
                            type: 'US',
                            zoom: 5, 
                            latlng: {lat: 39, lng: -87} as LatLng,
                            minZoom: 4,
                            maxZoom: 18};

export const defaultCounty = {type: 'County',
                              stfp: '',
                              name:'',
                              stabbr: '',
                              cntyfp:'',
                              latlng: {lat: 0, lng: 0}} as County;

export const defaultState = {type: 'State',
                             name:'', 
                             stfp:'',
                             latlng: defaultMap.latlng, 
                             zoom: 5,
                             stabbr: '',
                             selected: false} as State;

export const appTitle = 'Voting Access Monitor';

//Georgia, Louisiana, Mississippi, North Carolina, Ohio, Pennsylvania, South Carolina, Wisconsin
export const currentStates = ["13", "22", "28", "37", "39", "42", "45", "55"];